import React, { useEffect, useState } from "react";
import TopScrollingText from "../components/TopScrollingText";
import BelowLogoScrollingText from "../components/BelowLogoScrollingText";
import Header from "../components/Header";
import ProductList from "../components/ProductList";
import Footer from "../components/Footer";
import HeroBanner from "../components/HeroBanner";
import Testimonials from "../components/Testimonials";
import CategoryList from "../components/CategoryList";
import TotalOrders from "../components/TotalOrders";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { toast } from "react-toastify";
export default function HomePage() {
    const text = "Manufacturer | Wholesaler | Distributor | Dealer | Retailer";
    const [displayText, setDisplayText] = useState("");
    const [index, setIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [orderId, setOrderId] = useState("");
    const [orderStatus, setOrderStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        let timeout;
        if (index < text.length) {
            timeout = setTimeout(() => {
                setDisplayText((prev) => prev + text[index]);
                setIndex(index + 1);
            }, 200);
        } else {
            timeout = setTimeout(() => {
                setDisplayText("");
                setIndex(0);
            }, 4000);
        }
        return () => clearTimeout(timeout);
    }, [index, text]);
    const handleTrackOrder = async () => {
        if (!orderId) return toast.error("Enter Order ID");
        setShowModal(true)
        setLoading(true);
        try {
            const apiOrderId = orderId.replace(/^SA/, "");
            let url = webEndPoint + `order-status-history/order/${apiOrderId}`;
            const response = await makeRequest("get", url);
            if (response) {
                setOrderStatus(response.data);
            }
        } catch (err) {
            console.error(err);
            alert("Order not found");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="page-container">
            <TopScrollingText />
            <Header />
            <HeroBanner />
            <CategoryList />
            <div className="content-wrapper">
                <div className="info-container">
                    <div className="info-card highlight">
                        <h3>📏 Size Note</h3>
                        <p>Prefer one size extra. Slight variation of <strong>± 0.5 to 1 inch</strong> may occur during cutting & stitching.</p>
                    </div>
                    <div className="info-card">
                        <h3>🚚 Delivery</h3>
                        <p><strong>Tamil Nadu:</strong> 24 – 48 hours</p>
                        <p><strong>Other States:</strong> 7 – 8 days</p>
                    </div>
                    <div className="info-card">
                        <h3>📦 Order Policy</h3>
                        <p>Minimum order: <strong>2 pieces (You can mix any Pattern / Models)</strong></p>
                        <p>360° opening video is mandatory for any complaints.</p>
                    </div>
                    <div className="info-card contact">
                        <h3>📞 Customer Care</h3>
                        <a href="tel:+919360990836" className="call-btn">
                            +91 9360990836
                        </a>
                    </div>
                </div>
            </div>
            <div className="typing-wrapper">
                <span className="typing-text">{displayText}</span>
            </div>
            <Testimonials />
            <TotalOrders />
            <Footer />
            <div className="track-order-float" onClick={() => setShowModal(true)}>
                📦 Track Order
            </div>
            <a href="https://wa.me/919360990836" target="_blank" rel="noopener noreferrer" className="whatsapp-float"><FaWhatsapp size={28} /></a>
            <a href="https://www.instagram.com/senthan_amuthan_kids_wear?igsh=MWFzbnQ4Y3AyamY2MA==" target="_blank" rel="noopener noreferrer" className="instagram-float"><FaInstagram size={28} /></a>
            {showModal && (
                <div className="modal-overlayes">
                    <div className="modal-boxes">
                        <span className="close-btns" onClick={() => {
                            setShowModal(false); setOrderId(""); setOrderStatus(null);
                        }}>✖</span>
                        {!orderStatus ? (
                            <>
                                <h3>Track Your Order</h3>
                                <input type="text" placeholder="Enter Order ID" value={orderId} onChange={(e) => setOrderId(e.target.value)} />
                                <button onClick={handleTrackOrder} disabled={loading}>{loading ? "Checking..." : "Submit"}</button>
                            </>
                        ) : (
                            <>
                                <h3>Order Status</h3>                                
                                <p>{orderStatus[0]?.remarks ? orderStatus[0]?.remarks : "Order Status not Found"}</p>
                                <button onClick={() => { setOrderStatus(null); setOrderId(""); }}>Track Another</button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}